import Waitlist from "@component/landing/kikoff_card/waitlist";

import { Flow } from "../container";

import kikoffCardMobile from "./kikoff_card_mobile.png";

import styles from "./styles.module.scss";

function Hero({ flow }: { flow: Flow }) {
  return (
    <>
      <section className={styles["hero-section"]}>
        <div className={styles["image-wrapper"]}>
          <img
            alt="Kikoff Secured Credit Card mobile"
            className={styles["hero-phone"]}
            src={kikoffCardMobile.src}
          />
        </div>
        <div className={styles["text-wrapper"]}>
          <h1
            className={`${styles["hero-title"]} text:heading-1`}
            data-cy="kikoff-card-header"
          >
            Banking that builds credit
          </h1>
          <h4 className={`${styles["hero-subtitle"]} text:heading-4`}>
            Get the best perks of a banking service and all the power of credit
            building
          </h4>
          <Waitlist flow={flow} />
        </div>
      </section>
    </>
  );
}

export default Hero;
